<script setup lang="ts">
const props = defineProps<{
  fillBg?: string
  fillTT?: string
  fillOpacity?: string
}>()
</script>
<template>
  <svg
    :class="fillBg ? fillBg : 'text-tt-gray'"
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="24"
    fill="none"
    viewBox="0 0 23 24"
  >
    <path
      fill="currentColor"
      :fill-opacity="fillOpacity ? fillOpacity : '1'"
      d="M0 0h23v24H0z"
    />
    <path
      :fill="fillTT ? fillTT : '#000'"
      d="M5 9.574h6.083a2.212 2.212 0 0 0-2.222 2.222v5.871h2.575V7H7.574A2.577 2.577 0 0 0 5 9.574ZM12.547 7v10.667h2.574v-5.853A2.224 2.224 0 0 0 12.9 9.592h6.084A2.555 2.555 0 0 0 16.426 7h-3.88ZM6.287 17.685a1.287 1.287 0 1 0 0-2.574 1.287 1.287 0 0 0 0 2.574ZM17.713 17.685a1.287 1.287 0 1 0 0-2.575 1.287 1.287 0 0 0 0 2.575Z"
    />
  </svg>
</template>
